import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/Tabs';
import ProfileSettings from './components/ProfileSettings';
import NotificationSettings from './components/NotificationSettings';

const Settings = () => {
  const user = {
    name: 'John Doe',
    email: 'john@example.com',
    phone: '+1 234 567 890',
    bio: 'Student passionate about learning'
  };

  const notificationSettings = {
    emailNotifications: true,
    sessionReminders: true
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold mb-8">Settings</h1>
      
      <div className="bg-white rounded-xl shadow-sm">
        <Tabs defaultValue="profile">
          <TabsList>
            <TabsTrigger value="profile">Profile</TabsTrigger>
            <TabsTrigger value="notifications">Notifications</TabsTrigger>
          </TabsList>
          
          <div className="p-6">
            <TabsContent value="profile">
              <ProfileSettings 
                user={user}
                onUpdate={(data) => console.log('Update profile:', data)}
              />
            </TabsContent>
            
            <TabsContent value="notifications">
              <NotificationSettings
                settings={notificationSettings}
                onUpdate={(data) => console.log('Update notifications:', data)}
              />
            </TabsContent>
          </div>
        </Tabs>
      </div>
    </div>
  );
};

export default Settings;